export default "__VITE_ASSET__hKusOjfG__"